var _style, _path, _circle, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF9811;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#6DA544;}\n\t.st3{fill:#A2001D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,44.5L0,44.5l0,423h0V256V44.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 256,
    cy: 256,
    r: 256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.3,44.5h-88.6c-3.9,2.7-7.8,5.5-11.5,8.4L77.9,256l22.3,203.1c3.8,2.9,7.6,5.7,11.5,8.4h88.6V44.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,256c0,82.7,39.3,156.3,100.2,203.1V52.9C39.3,99.7,0,173.3,0,256L0,256z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.8,156.1v6.4l0.2,0L411.8,156.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M491.6,322.8h-48.2L423,345v44.5h-44.5v-22.3h22.3v-44.5H300.5v27.8h-22.3v-53c-6.8-6.1-11.1-15-11.1-24.9V128 c0-18.4,15-33.4,33.4-33.4v205.9H345l15.3-12.7c-2.7-6.4-4.1-13.3-4.1-20.7v-33.4h-33.4V167h66.8c0-11.1,16.7-22.3,16.7-22.3 S423,155.8,423,167v16.7v50.1c12.4,0.1,32.1-0.2,53.3,0c-5.6-9.8-8.8-21.3-8.8-33.4c0-19.6,8.5-37.3,22-49.5 C470,107.7,439,71,400.3,44.5H233.7v423h166.5c47-32.1,82.8-79.6,100.1-135.1L491.6,322.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/lk.422571925064af7ff1421ab5ff194ec5.svg";
export { ForwardRef as ReactComponent };